import { render } from "./Breadcrumb.vue?vue&type=template&id=7a0508f4"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Breadcrumb.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a0508f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a0508f4', __exports__)) {
    api.reload('7a0508f4', __exports__)
  }
  
  module.hot.accept("./Breadcrumb.vue?vue&type=template&id=7a0508f4", () => {
    api.rerender('7a0508f4', render)
  })

}


export default __exports__